import { assetsHostFor } from "./assetsHost"
import { ASSETS_FROM_API } from "./consts"
import { useAppStore } from "@src/state"

// Any babele.co host: prod, staging, previews and their asset hosts.
const isBabeleHost = (host: string) =>
  host === "babele.co" || host.endsWith(".babele.co")

// Folders the file migration put in the private bucket; every other folder is public.
const PRIVATE_FOLDERS = [
  "resources",
  "resource_files",
  "attachments",
  "form_answers",
]

const UPLOADS_ROOT = /^images\/uploads\//i
const VOLUME_ROOT = /^images\//i

// Files uploaded before the cutover keep their saved Images/ paths; they are served from the buckets under assets/<class>/<folder>/<file>.
export const toAssetsPath = (url: string): string => {
  let path = url
  const absolute = path.match(/^https?:\/\/([^/?#]+)(.*)$/i)
  if (absolute) {
    const host = absolute[1].toLowerCase()
    const customDnsHost = useAppStore.getState().customDnsHost
    if (!isBabeleHost(host) && host !== customDnsHost?.toLowerCase()) return url
    path = absolute[2]
  }

  const queryStart = path.search(/[?#]/)
  const suffix = queryStart < 0 ? "" : path.slice(queryStart)
  const normalized = (queryStart < 0 ? path : path.slice(0, queryStart))
    .replace(/\\/g, "/")
    .replace(/\/{2,}/g, "/")
    .replace(/^\//, "")

  if (/^assets\/(public|private)\//.test(normalized)) return normalized + suffix

  if (UPLOADS_ROOT.test(normalized)) {
    const key = normalized.replace(UPLOADS_ROOT, "")
    const folder = key.split("/")[0].toLowerCase()
    const assetsClass = PRIVATE_FOLDERS.includes(folder) ? "private" : "public"
    return `assets/${assetsClass}/${key}${suffix}`
  }

  if (VOLUME_ROOT.test(normalized))
    return `assets/public/${normalized}${suffix}`

  return url
}

// With assets from the API, a saved path of any upload, old or new, loads through /assets on the host that serves it.
export const assetsUrlFromApi = (pathOrUrl: string): string | undefined => {
  if (!ASSETS_FROM_API) return undefined
  const assetsPath = toAssetsPath(pathOrUrl)
  return assetsPath.startsWith("assets/")
    ? `${assetsHostFor(assetsPath)}/${assetsPath}`
    : undefined
}
